import initialState from './initial';
import { actionTypes } from './actions';

export const reducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.GET_MY_BETS:
      return {
        ...state,
        myBets: payload.games,
      }

    case actionTypes.GET_TOP_WINS_SUCCESS:
      return {
        ...state,
        topWins: payload.top_wins,
      }  

    case actionTypes.SET_IS_PROCESS:
      return { ...state, isProcess: payload }

    case actionTypes.UPDATE_BET:
      return {
        ...state, myBets: state.myBets.map(t => t.game_id === payload.roundID ? { ...t, win_amount: payload.win_amount } : t)
      }  

    default: return state;
  }
}